export default "__VITE_ASSET__BfF79zt8__"